export default {
  DATA_SIZE: 'data-size',
  DATA_STATUS: 'data-status'
};